var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-option pull-right"},[_vm._v("\n    Poster Size:\n    "),_c('div',{staticStyle:{"width":"100px","display":"inline-block","margin-left":"7px"},attrs:{"id":"posterSizeSlider"}})])
}]

export { render, staticRenderFns }